import React from 'react';

import { Page, PageContent, PageHeader } from '@vlabs/monokit/shared/ui/page/index.ts';
import { getDiagrams } from '@vlabs/shared/assets/images/diagrams/diagrams';
import { useTheme } from '@vlabs/shared/context/ThemeContext';
import { routes } from '@vlabs/shared/navigation/routes.ts';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router-dom';

import st from './StatisticPage.module.sass';
import { StatisticsCard } from './StatisticsCard';

export function StatisticPage() {
  const { t } = useTranslation();
  const { isLightTheme } = useTheme();
  const history = useHistory();

  const diagrams = getDiagrams(isLightTheme);

  const onClick = (type) => {
    const eventLink = generatePath(routes.events.statistic.read, { diagramType: type });
    history.push(eventLink);
  };

  return (
    <Page>
      <PageContent>
        <PageHeader title={t('statistic:titles.page')} />
        <div className={st.StatisticsGrid}>
          <StatisticsCard
            image={diagrams.AgeDistribution}
            onClick={() => onClick('ageDistribution')}
            testid="ageDistribution"
            title={t('statistic:titles.age_distribution')}
          />
          <StatisticsCard
            image={diagrams.AttendanceByGender}
            onClick={() => onClick('attendanceByGender')}
            testid="attendanceByGender"
            title={t('statistic:titles.attendance_by_gender')}
          />
          <StatisticsCard
            image={diagrams.GenderDistribution}
            onClick={() => onClick('genderDistribution')}
            testid="genderDistribution"
            title={t('statistic:titles.gender_distribution')}
          />
          <StatisticsCard
            image={diagrams.GenderRatio}
            onClick={() => onClick('genderRatio')}
            testid="genderRatio"
            title={t('statistic:titles.gender_ratio')}
          />
          <StatisticsCard
            image={diagrams.EmotionDistribution}
            onClick={() => onClick('emotionDistribution')}
            testid="emotionDistribution"
            title={t('statistic:titles.emotion_distribution')}
          />
          <StatisticsCard
            image={diagrams.AverageAgeDynamics}
            onClick={() => onClick('averageAgeByGender')}
            testid="averageAgeByGender"
            title={t('statistic:titles.average_age_dynamics')}
          />
        </div>
      </PageContent>
    </Page>
  );
}
